import { Brand } from 'effect'

type MarketingListId = string & Brand.Brand<'MarketingListId'>

const MarketingListId = {
  make: Brand.nominal<MarketingListId>(),
}

export default MarketingListId
